<template>
    <v-dialog v-model="dialog" max-width="600">
        <template v-slot:activator="{ on }">
            <v-btn color="orange" fab absolute bottom right v-on="on" class="d-none d-sm-block">
                <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn color="orange" fab fixed bottom right v-on="on" class="d-block d-sm-none">
                <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="headline" primary-title>
                <div v-if="cardTraitId > 0">
                    <v-btn icon @click="indexCardButtons">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    Titles
                </div>
                <div v-else-if="cardTypeId > 0">
                    <v-btn icon @click="indexCardButtons">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    Traits
                </div>
                <div v-else>
                    Types
                </div>
            </v-card-title>

            <v-card-text>
                <v-row v-for="(cardButton, cardButtonIndex) in cardButtons"
                       :key="cardButtonIndex">
                    <v-col>
                        <v-card flat outlined color="grey" class="lighten-4">
                            <v-row>
                                <v-col>
                                    <v-btn block
                                           text
                                           @click="attachRandomCard(cardButtonIndex)"
                                           :loading="attachingCard === cardButtonIndex"
                                           :disabled="attachingCard !== null">
                                        {{ cardButton.title }}
                                    </v-btn>
                                </v-col>
                                <v-col class="text-end mr-6" v-if="cardTypeId === null && cardTraitId === null">

                                    <v-tooltip bottom>
                                        <template #activator="{on}">
                                            <v-btn icon
                                                   @click="viewTypeTraits(cardButtonIndex)"
                                                   v-on="on"
                                                   :loading="loadingTrait === cardButtonIndex"
                                                   :disabled="loadingTrait !== null || loadingTitle !== null">
                                                <v-icon>mdi-tag-outline</v-icon>
                                            </v-btn>
                                        </template>

                                        <span>Traits</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{on}">
                                            <v-btn icon
                                                   @click="viewTypeTitles(cardButtonIndex)"
                                                   v-on="on"
                                                   :loading="loadingTitle === cardButtonIndex"
                                                   :disabled="loadingTrait !== null || loadingTitle !== null">
                                                <v-icon>mdi-subtitles-outline</v-icon>
                                            </v-btn>
                                        </template>

                                        <span>Titles</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                </v-row>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" text @click="dialog = false">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import CardService from "../services/CardService";
  import InvestigatorSessionService from "../services/InvestigatorSessionService";

  export default {
    props: ["game", "investigatorSessionIndex"],

    data: () => ({
      dialog: null,
      cardButtons: [],
      loadingTrait: null,
      loadingTitle: null,
      attachingCard: null,
      cardTypeId: null,
      cardTraitId: null
    }),

    watch: {
      dialog: function (val) {
        if (val) {
          this.indexCardButtons();
        } else {
          this.cardButtons = [];
        }
      }
    },

    methods: {
      indexCardButtons() {
        CardService.indexTypesByGame(this.game.id)
          .then(response => {
            this.cardButtons = response.data.data;
            this.cardTypeId = null;
            this.cardTraitId = null;
          });
      },

      attachRandomCard(index) {
        let form;

        this.attachingCard = index;

        if (this.cardTraitId) {
          form = {
            card_front_ids: [this.cardButtons[index].id]
          };
        } else if (this.cardTypeId) {
          form = {
            card_type_ids: [this.cardTypeId],
            card_trait_ids: [this.cardButtons[index].id]
          };
        } else {
          form = {
            card_type_ids: [this.cardButtons[index].id]
          };
        }

        form.game_pack_ids = this.game.game_pack_selection;

        InvestigatorSessionService.attachRandomCard(this.game.activeInvestigatorSessions[this.investigatorSessionIndex].id, form)
          .then(() => {
            this.$emit("attachedCard");
          })
          .finally(() => {
            this.attachingCard = null;
            this.dialog = false;
          });
      },

      viewTypeTraits(index) {
        this.loadingTrait = index;

        CardService.indexFilteredTraits(this.getIndexForm(index))
          .then(response => {
            this.cardTypeId = this.cardButtons[index].id;
            this.cardButtons = response.data.data;
          })
          .finally(() => {
            this.loadingTrait = null;
          });
      },

      viewTypeTitles(index) {
        this.loadingTitle = index;

        CardService.indexFilteredFronts(this.getIndexForm(index))
          .then(response => {
            this.cardTraitId = this.cardButtons[index].id;
            this.cardButtons = response.data.data;
          })
          .finally(() => {
            this.loadingTitle = null;
          });
      },

      getIndexForm(index) {
        let form = {};
        form.game_pack_ids = this.game.game_pack_selection;
        form.game_id = this.game.id;
        form.card_type_id = this.cardButtons[index].id;

        return form;
      }
    }
  };
</script>